import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  watch: {
    chartData(chartData) {
      this.renderChart(chartData, this.options);
    },
    options(options) {
      this.renderChart(this.chartData, options);
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
}
